module.exports = __webpack_public_path__ + "img/07.37b7bb83.png";